/**
 * Enumération des identifiants de portée liées aux conforts pour les transports de type train et avion
 */
export enum PorteeConfort {
    AVION = 'TA',
    TRAIN = 'TT'
}